/* import __COLOCATED_TEMPLATE__ from './alias-tooltip.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();